import clsx from 'clsx'
import { format } from 'date-fns'

import { DOWNLOAD_API } from '@/api'
import { Row } from '@/components/core-v2'
import { DownloadLink, onDownloadLinkClick } from '@/components/core-v2/molecules/download-link'

import classes from './index.module.scss'

interface Props {
  noteId: string
  pastStatementDates: Date[]
}

export const StatementsTab = ({ noteId, pastStatementDates }: Props) => (
  <>
    <Row showBottomBorder className={clsx(classes.mostRecentRow, 'flex-space-between')}>
      <strong>Latest statement</strong>
      <DownloadLink
        onClick={() =>
          onDownloadLinkClick({
            url: DOWNLOAD_API.exportLiveStatement(noteId)
          })
        }
      >
        Export statement
      </DownloadLink>
    </Row>

    <div className={classes.previousWrapper}>
      <h4>Previous</h4>
      <DownloadLink
        onClick={() =>
          onDownloadLinkClick({
            url: DOWNLOAD_API.exportPreviousStatements(noteId)
          })
        }
      >
        Export all statements
      </DownloadLink>
    </div>
    {pastStatementDates.length === 0 && (
      <div className={clsx(classes.pastStatementsEmptyState, 'flex-center')}>
        <p>This is where your statements will appear at the end of each month</p>
      </div>
    )}
    {pastStatementDates.reverse().map((date, index, array) => {
      const formattedDate = format(date, 'LLLL yyyy')
      const isLastItem = index === array.length - 1
      return (
        <Row key={formattedDate} className="flex-space-between" showBottomBorder={isLastItem}>
          <strong>{formattedDate}</strong>
          <DownloadLink
            onClick={() =>
              onDownloadLinkClick({
                url: DOWNLOAD_API.exportNoteStatement(
                  noteId,
                  format(date, 'yyyy'),
                  format(date, 'M')
                )
              })
            }
          >
            Export statement
          </DownloadLink>
        </Row>
      )
    })}
  </>
)
